import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import "./App.css";
import { Box, Container } from "@mui/material";
import Header from "./shared-components/header";
import Footer from "./shared-components/footer";
import { useSelector } from "react-redux";
import _ from "lodash";
import {
  menuItemList,
  menuList,
  selectIsLoading,
  userDetail,
} from "./redux/slice/userSlice";
import ApiLoader from "./shared-components/apiLoader";
import { useContext, useEffect, useState } from "react";
import { AuthenticationContext } from "@cloudmlm/cloudmlm-auth";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import LoginPage from "./main/login";
import urlConstant from "./constants/urlConstants";
import { httpGet, httpPost } from "./services/commonService";
import componentMap from "./ComponentMap";
import NotFoundPage from "./main/NotFound";
import store from "./redux/store";
import ManageMembership from "./main/myAccount/manageMembership";
import MediaPage from "./main/mediaPage/mediaPage";
import WithDrawFunds from "./main/iWallet/withDrawFunds";
import dataConstant from "./constants/dataConstants";
import ManageProjects from "./main/projects/manageProjects";
import AffiliateSignUp from "./main/affiliateSignUp/affiliateSignUp";
import IBOSignup from "./main/IBOSignup/IBOSignup";
import Thankyou2 from "./main/iWallet/thankYou2";
import ManageAffiliateProjects from "./main/affiliateProjects/manageAffiliateProjects";
import ViewOrder from "./main/orders/viewOrder";
import IBOFreeBYLDerSignup from "./main/IBOFreeBYLDerSignup/IBOFreeBYLDerSignup";
import TermsAndConditions from "./main/termsAndConditions/termsAndConditions";
import SeamlessAuthProcessor from "./main/seamlessAuth/seamlessAuthProcessor";
import SponsorTree1 from "./main/myTeam/sponsorTree1";
import { startApiLoader, endApiLoader } from "./services/apiLoaderService";

function extractItemMenus(data) {
  const result = [];

  function recurse(items) {
    items.forEach((item) => {
      if (item.type === "item") {
        result.push(item);
      }

      if (Array.isArray(item.children) && item.children.length > 0) {
        recurse(item.children);
      }

      if (Array.isArray(item.InnerChildren) && item.InnerChildren.length > 0) {
        recurse(item.InnerChildren);
      }
    });
  }

  recurse(data);
  return result;
}

const PrivateRoute = ({ Component }) => {
  const { isLoggedIn } = useContext(AuthenticationContext);
  return isLoggedIn ? (
    <ProtectedRoute>
      <Component />
    </ProtectedRoute>
  ) : (
    <Navigate to="/login" />
  );
};

const ProtectedRoute = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
);

function AppRoutes() {
  const navigate = useNavigate();
  const location = useLocation();
  const getApiLoader = useSelector(selectIsLoading);
  const { isLoggedIn, accessToken, impersonateEmail, isLoading, logUserOut } = useContext(AuthenticationContext);
  const [dynamicRoutes, setDynamicRoutes] = useState([]);
  const [isLoadingMenus, setIsLoadingMenus] = useState(true);

  const publicPaths = [
    { pathName: "/login", arguments: 1, argumentsTotal: 2 },
    { pathName: "/affiliatesignup", arguments: 1, argumentsTotal: 2 },
    { pathName: "/AventiAffiliateSignup", arguments: 1, argumentsTotal: 2 },
    { pathName: "/IBOSignup", arguments: 2, argumentsTotal: 3 },
    { pathName: "/FreeBYLDerSignup", arguments: 2, argumentsTotal: 2 },
    { pathName: "/termsandconditions", arguments: 2, argumentsTotal: 2 },
    { pathName: "/seamless-auth", arguments: 2, argumentsTotal: 2 },
  ];

  const publicRoutes = [
    { path: "/login/:refName?", element: <LoginPage /> },
    { path: "/affiliatesignup/:refName?", element: <AffiliateSignUp /> },
    { path: "/AventiAffiliateSignup/:refName?", element: <AffiliateSignUp /> },
    { path: "/IBOSignup/:packageName/:refName?", element: <IBOSignup /> },
    { path: "/FreeBYLDerSignup/:Id", element: <IBOFreeBYLDerSignup /> },
    { path: "/termsandconditions/:prevPage", element: <TermsAndConditions /> },
    { path: "/seamless-auth/:key", element: <SeamlessAuthProcessor /> },
  ];

  const SPRITE_URL = `${process.env.REACT_APP_BLOB_URL}/backoffice-assets/sprite-icon.svg`;

  useEffect(() => {
    fetch(SPRITE_URL)
    .then(res => res.text())
    .then(data => {
        const div = document.createElement('div');
        div.style.display = 'none';
        div.innerHTML = data;
        document.body.insertBefore(div, document.body.firstChild);
    });
  }, []);
  
  useEffect(() => {
    if (!isLoading) {
      const currentPath = location.pathname;
      const getAllSegments = _.split(currentPath, "/").filter(Boolean);
      const firstSegment = "/" + getAllSegments[0];
      const isPublicPath = _.find(
        publicPaths,
        (item) => item.pathName === firstSegment
      );
      if (isLoggedIn) {
        getBackOfficeMenuList();
        getUserLoggedDetails();
      } else {
        setIsLoadingMenus(false);
        if (
          isPublicPath === undefined ||
          (isPublicPath.arguments !== getAllSegments.length &&
            isPublicPath.argumentsTotal !== getAllSegments.length)
        ) {
          navigate("/login");
        }
        const getPathArray = location.pathname?.split("/")?.filter(Boolean)
        if (getPathArray[1] !== undefined && getPathArray[0].toLowerCase() === "login" && getPathArray[1].toLowerCase() === "aventitravel"){
          navigate(`/login${getPathArray?.length === 2 ? `/${getPathArray[1]}` : ""}`)
          localStorage.setItem("previousPath", getPathArray[1])
        }
      }
    }
  }, [isLoggedIn, isLoading, impersonateEmail]);

  const getBackOfficeMenuList = () => {
    const getBackOfficeMenuURL =
      urlConstant.BackOfficeMenu.GetBackOfficeMenuList;
    httpGet(getBackOfficeMenuURL, true, true, accessToken, impersonateEmail)
      .then((response) => {
        if (response.status === dataConstant.APIResponseCode.Unauthorized) {
          logUserOut();
          return;
        }
        const getAllItem = extractItemMenus(response.Value.Data);
        store.dispatch(menuList({ menuList: response.Value.Data }));
        store.dispatch(menuItemList({ menuItemList: getAllItem }));
        const mappedRoutes = getAllItem.map((menu) => ({
          path: menu.navLink,
          component: menu.title.replace(/\s+/g, ""),
        }));
        setDynamicRoutes(mappedRoutes);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setIsLoadingMenus(false));
  };

  const getUserLoggedDetails = () => {
    const getUserLoggedDetailURL = urlConstant.User.GetUserLoggedDetails;
    httpGet(getUserLoggedDetailURL, true, false, accessToken, impersonateEmail)
      .then((response) => {
        if (response.status === dataConstant.APIResponseCode.Unauthorized) {
          logUserOut();
          return;
        }
        if (response.Value.Status === dataConstant.APIResponseStatus.Success) {
          store.dispatch(userDetail({ userDetail: response.Value.Data }));
          if (localStorage.getItem("aventitravelTrip") === "true") {
            localStorage.removeItem("aventitravelTrip");
            localStorage.setItem(
              "HasValidTrialAventiUser",
              response.Value.Data.HasValidTrialAventiUser
            );
            loginTravertexAccount();
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleOpenNewPage = (redirectURL) => {
    const newWindow = window.open();
    if (newWindow) {
      newWindow.document.write(redirectURL);
      newWindow.document.close();
    } else {
      alert("Please allow popups to open the redirect page.");
    }
  };
  
  const loginTravertexAccount = () => {
    startApiLoader();
    const modelData = {
      FreeTrial: localStorage.getItem("HasValidTrialAventiUser") === "true" ? true : false,
    };
    httpPost(
      urlConstant.Travertex.LoginTravertexAccount,
      modelData,
      true,
      true,
      accessToken,
      impersonateEmail
    ).then((response) => {
      if (response?.Status === dataConstant.APIResponseStatus.Failure) {
        //navigate("/home");
      }
      if (response?.Status === dataConstant.APIResponseStatus.Success) {
        handleOpenNewPage(response?.Value?.userLoginResponse?.Response?.RedirectURL);
      }
      navigate("/aventitravel");
      endApiLoader();
    })
    .catch((err) => {
      navigate("/aventitravel");
      endApiLoader();
      console.error(err);
    }).finally(() => {
      localStorage.removeItem("previousPath");
      localStorage.removeItem("HasValidTrialAventiUser");
    });
  };

  return (
    <>
      {!isLoadingMenus ? (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          {getApiLoader && <ApiLoader />}
          <Box display="flex" flexDirection="column" minHeight="100vh">
            <Container
              className="main-page-container"
              maxWidth="xxl"
              sx={{ mt: 0, mb: 0, px: "0" }}
            >
              <Routes>
                {dynamicRoutes.map(({ path, component }) => {
                  const Component = componentMap[component];
                  if (Component !== undefined) {
                    return (
                      <Route
                        key={path}
                        path={path}
                        element={<PrivateRoute Component={Component} />}
                      />
                    );
                  }
                  return null;
                })}
                {_.find(dynamicRoutes, (item) => item.path === "/membership") !== undefined && <Route
                  key="/manageMembership"
                  path="/manageMembership/:Id?"
                  element={<PrivateRoute Component={ManageMembership} />}
                />}
                <Route
                  key="/mediaPage"
                  path="/mediaPage/:id"
                  element={<PrivateRoute Component={MediaPage} />}
                />
                <Route
                  key="/withDrawFunds"
                  path="/withDrawFunds"
                  element={<PrivateRoute Component={WithDrawFunds} />}
                />
                {_.find(dynamicRoutes, (item) => item.path === "/projects") !== undefined && <Route
                  key="/manageProjects"
                  path="/manageProjects/:id?"
                  element={<PrivateRoute Component={ManageProjects} />}
                />}
                <Route
                  key="/thankYou2"
                  path="/thankYou2"
                  element={<PrivateRoute Component={Thankyou2} />}
                />
                 <Route
                  key="/sponsorTree1"
                  path="/sponsorTree1"
                  element={<PrivateRoute Component={SponsorTree1} />}
                />
                {_.find(dynamicRoutes, (item) => item.path === "/affiliateProjects") !== undefined && <Route
                  key="/manageAffiliateProjects"
                  path="/manageAffiliateProjects"
                  element={<PrivateRoute Component={ManageAffiliateProjects} />}
                />}
                <Route
                  key="/vieworder"
                  path="/vieworder/:id"
                  element={<PrivateRoute Component={ViewOrder} />}
                />
                {publicRoutes.map(({ path, element }) => (
                  <Route key={path} path={path} element={element} />
                ))}
                {isLoggedIn && (
                  <Route path="/" element={<Navigate to="/home" replace />} />
                )}
                {dynamicRoutes.length > 0 && (
                  <Route path="*" element={<NotFoundPage />} />
                )}
              </Routes>
            </Container>
          </Box>
        </LocalizationProvider>
      ) : (
        getApiLoader && <ApiLoader />
      )}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;